import { LabelValueRow } from 'components/core-v2'

export const NoteDetailsTableStubbed = () => (
  <>
    <LabelValueRow label="Name" value="–" />
    <LabelValueRow data-private label="Client" value="–" />
    <LabelValueRow data-private label="Business unit" value="–" />
    <LabelValueRow label="ID" value="–" />
    <LabelValueRow label="Start date" value="–" />
    <LabelValueRow label="End date" value="–" />
    <LabelValueRow label="Distribution processing" value="–" />
    <LabelValueRow label="Tax classification" value="–" />
    <LabelValueRow label="Counterparty ID" value="–" />
    <LabelValueRow label="Current value of the note (all trades)" value="–" />
    <LabelValueRow label="Number of active trades in this note" value="–" />
    <LabelValueRow showBottomBorder label="Number of closed trades in this note" value="–" />
  </>
)
